<template>
    <div class="my-habits-edit-modal">

        <!-- edit button -->
        <b-btn size="sm" class="btn-edit btn-icon" variant="default"
               @click.stop="showModal()">
            <shs-icon :name="habit ? 'pencil' : 'plus'"></shs-icon>
        </b-btn>

        <!-- modal -->
        <data-form-modal :modal-id="modalId"
                         :title="$i18n.gt('LABEL_EDIT_HABIT')"
                         :save-button-label="$i18n.gt('LABEL_SAVE')"
                         :field-model="habitFields"
                         :field-groups="fieldGroups"
                         :model-instance="editingHabit"
                         :on-cancel-handler="cancelModal"
                         :on-submit-handler="saveParticipant">

            <!-- additional content for modal footer -->
            <template v-slot:modal-footer-extra>
                <b-btn class="btn-delete"
                       v-if="habit"
                       @click="archiveHabit()">
                    {{ $i18n.gt('LABEL_ARCHIVE_HABIT') }}
                    <shs-icon name="delete"></shs-icon>
                </b-btn>
            </template>

        </data-form-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import HabitFields from '@/models/Habit'

/**
 * Button and modal to edit an individual wellness Habit
 */

export default Vue.extend({
    name: 'MyHabitsEditModal',
    props: {
        habits: Array,
        // both empty if adding a new habit
        habit: Object,
        index: {type: Number, default: -1}
    },
    data() {
        return {
            editingHabit: this.getEditingHabit(),
            habitFields: HabitFields,
            fieldGroups: [['habit', 'categories']],
        }
    },
    computed: {
        modalId() {
            return `habitModal_${this.index}`
        }
    },
    methods: {
        getEditingHabit() {
            if (this.habit) {
                return this.habit
            } else {
                return {habit: '', categories: '', reminder: false}
            }
        },
        showModal() {
            this.editingHabit = this.getEditingHabit()
            if (!this.habit) {
                this.habits.push(this.editingHabit) // creating a new habit
            }
            this.$bvModal.show(this.modalId)
        },
        cancelModal() {
            if (!this.habit) {
                this.$delete(this.habits, this.habits.length - 1) // remove added habit
            }
        },
        archiveHabit() {
            this.$bvModal.msgBoxConfirm(this.$i18n.gt('MESSAGE_ARCHIVE_HABIT'))
                .then((value) => {
                    if (value) {
                        Vue.set(this.editingHabit, 'archivedTimestamp', new Date())
                        this.$bvModal.hide(this.modalId)
                        this.saveParticipant()
                    }
                })
        },
        saveParticipant() {
            this.$store.dispatch('savePatientParticipant')
                .then(() => {
                    // reset modal in case we want to create another habit
                    this.editingHabit = this.getEditingHabit()
                })
        }
    },
})
</script>
